// utils/exportToExcel.js
import { utils, write } from 'xlsx';
import { saveAs } from 'file-saver';

export const exportToExcel = (exportData, filename = 'export') => {
  if (!exportData || exportData.length === 0) {
    alert('No data to export');
    return;
  }

  // Convert the selected data into a sheet
  const worksheet = utils.json_to_sheet(exportData);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  // Write the workbook to a binary Excel file
  const excelBuffer = write(workbook, { bookType: 'xlsx', type: 'array' });
  
  // Create a Blob object and save it as an Excel file
  const fileBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(fileBlob, `${filename}_${new Date().toISOString().split('T')[0]}.xlsx`);
};
